import AgoraRTC from 'agora-rtc-sdk'
var localStream;
var videoStream =  AgoraRTC.createClient({mode: 'live', codec: "h264"});
var $ = require("jquery");

function addView (id, show) {
    if (!$("#" + id)[0]) {
      $("<div/>", {
        id: "remote_video_panel_" + id,
        class: "video-view",
      }).appendTo("#video");
      $("<div/>", {
        id: "remote_video_" + id,
        class: "video-placeholder",
      }).appendTo("#remote_video_panel_" + id);
      $("<div/>", {
        id: "remote_video_info_" + id,
        class: "video-profile " + (show ? "" :  "hide"),
      }).appendTo("#remote_video_panel_" + id);
      $("<div/>", {
        id: "video_autoplay_"+ id,
        class: "autoplay-fallback hide",
      }).appendTo("#remote_video_panel_" + id);
    }
  }

  function removeView (id) {
    if ($("#remote_video_panel_" + id)[0]) {
      $("#remote_video_panel_"+id).remove();
    }
  }

export const startTheStream = function (camera, microphone, role) {
    var channel_key = null;
    var streamId = '';    
    function join(){
        return videoStream.join(channel_key, 'black_answer__streaming_channel', null, function(uid) {
            console.log("User " + uid + " join channel successfully");    
              if (role){
               localStream = AgoraRTC.createStream({
                  streamID: null, 
                  audio: true, 
                  cameraId: camera, 
                  microphoneId: microphone, 
                  video: true, 
                  screen: false}
                );
                localStream.init(function() {
                    console.log("getUserMedia successfully");
                    //if (host) localStream.play('black_answer_player');
                
                    videoStream.publish(localStream, function (err) {
                      console.log("Publish local stream error: " + err);
                    });
                
                    videoStream.on('stream-published', function (evt) {
                      console.log("Publish local stream successfully");
                    });
                  }, function (err) {
                    console.log("getUserMedia failed", err);
                });
    
                // The user has granted access to the camera and mic.
                localStream.on("accessAllowed", function() {
                    console.log("accessAllowed");
                });
                
                // The user has denied access to the camera and mic.
                localStream.on("accessDenied", function() {
                    console.log("accessDenied");
                });
            }
        }, function(err) {
            console.log("Join channel failed", err);
          });
    }
    
    if(!AgoraRTC.checkSystemRequirements()) {
       alert("Your browser does not support WebRTC!");
       return;
    }
    
    videoStream.init('45cab9521e694d3bba827644518aa9f4', function () {
        console.log("AgoraRTC client initialized");
        streamId = join()
     }, function (err) {
        console.log("AgoraRTC client init failed", err);
    });


    videoStream.on('error', function(err) {
        console.log("Got error msg:", err.reason);
        if (err.reason === 'DYNAMIC_KEY_TIMEOUT') {
            videoStream.renewChannelKey(channel_key, function(){
            console.log("Renew channel key successfully");
            }, function(err){
            console.log("Renew channel key failed: ", err);
            });
        }
    });

    videoStream.on('stream-added', function (evt) {
        var stream = evt.stream;
        console.log("New stream added: " + stream.getId());
        console.log("Subscribe ", stream);
        videoStream.subscribe(stream, function (err) {
            console.log("Subscribe stream failed", err);
        });
    });
    
    videoStream.on('stream-subscribed', function (evt) {
        var stream = evt.stream;
        var id = stream.getId();
        //addView(id);
        stream.play('black_answer_player');
        console.log("Subscribe remote stream successfully: " + stream.getId());
      });
    
      videoStream.on('stream-removed', function (evt) {
        var stream = evt.stream;
        var id = stream.getId();
        if (stream.isPlaying()) stream.stop('black_answer_player');
        //removeView(id);
        console.log("Remote stream is removed " + stream.getId());
    });
      
    videoStream.on('peer-leave', function (evt) {
        var stream = evt.stream;
        if (stream) {
          if (stream.isPlaying()) stream.stop();
          console.log(evt.uid + " leaved from this channel");
        }
    });
    
      function leave() {
        videoStream.leave(function () {
          console.log("Leavel channel successfully");
        }, function (err) {
          console.log("Leave channel failed");
        });
      }
    
    function publish() {
        videoStream.publish(localStream, function (err) {
          console.log("Publish local stream error: " + err);
        });
    }
    
    function unpublish() {
        videoStream.unpublish(localStream, function (err) {
          console.log("Unpublish local stream failed" + err);
        });
    }
}

export const closeTheStream = () =>{
  if (videoStream){
    videoStream.unpublish(localStream, function (err) {
      console.log("Unpublish local stream failed" + err);
    });
    videoStream.leave(function () {
      console.log("Leave channel streaming successfully");
      if (localStream && localStream.isPlaying() ){
           localStream.stop();
      }
      if (localStream)  localStream.close();  
      while (localStream && localStream.length > 0) {
        var stream = localStream.shift();
        var id = stream.getId();
        stream.stop();
        //removeView(id);
      }
    }, function (err) {
      console.log("Leave channel streaming failed");
    });
  }
}
  

  














// WEBPACK FOOTER //
// ./src/utils/VideoStream.js